<template>
    <section id="installation-faqs" aria-label="FAQs">
        <section v-if="hasSearchBox || hasSearchButton">
            <h4>{{texts.faqs.searchBoxQuestion}}</h4>
			<p>{{texts.faqs.searchBoxSection}}</p>
			<CodeBlock :key="'sb_faq_section'+sbC+'_'+sbtnC + '_' + searchBoxPlaceholder" data-tracking="searchbox">&lt;section role="search" data-ss360="true"><br>   &lt;input id="{{searchBoxId}}" type="search" placeholder="{{searchBoxPlaceholder}}" /&gt;<br>   &lt;button id="{{searchButtonId}}"/&gt;<br>&lt;/section&gt;</CodeBlock>
            <p>{{texts.faqs.searchBoxControls}}</p>
			<ul>
				<li>
					<p>{{texts.faqs.searchBoxControlsHint}}</p>
					<CodeBlock :key="'sb_faq'+sbC + '_' + searchBoxPlaceholder" data-tracking="searchbox">&lt;input id="{{searchBoxId}}" type="search" placeholder="{{searchBoxPlaceholder}}" /&gt;</CodeBlock>
					<p class="span" v-if="source==='wordpress'">{{texts.faqs.searchBoxWp}}</p>
					<CodeBlock v-if="source==='wordpress'" :key="'sb_faq_wp'+sbC" data-tracking="searchbox_wp">[ss360-searchbox]</CodeBlock>	
				</li>
				<li>
					<p>{{texts.faqs.searchBoxAndButtonHint}}</p>
					<CodeBlock :key="'sb_faq'+sbC+'_'+sbtnC + '_' + searchBoxPlaceholder" data-tracking="searchbutton">&lt;input id="{{searchBoxId}}" type="search" placeholder="{{searchBoxPlaceholder}}" /&gt;<br/>&lt;input type="submit" id="{{searchButtonId}}"/&gt;</CodeBlock>
					<p class="span" v-if="source==='wordpress'">{{texts.faqs.searchButtonWp}}</p>
            		<CodeBlock v-if="source==='wordpress'" :key="'sbbtn_faq_wp'+sbC" data-tracking="searchbutton_wp">[ss360-searchbutton]{{texts.faqs.searchButtonLabel}}[/ss360-searchbutton]</CodeBlock>
				</li>
			</ul>
			<p>{{texts.faqs.postInstallHint}}</p>
        </section>
        <section v-if="isFullscreen">
            <h4>{{texts.faqs.triggerQuestion}}</h4>
            <span class="span">{{texts.faqs.triggerSolution}}</span>
            <CodeBlock :key="'fs_faq'+stC" data-tracking="trigger">&lt;button id="{{searchTriggerId}}"&gt;{{texts.faqs.triggerLabel}}&lt;/button&gt;</CodeBlock>
        </section>
    </section>
</template>

<script>
import CodeBlock from "./CodeBlock";
export default {
    name: "InstallationFAQ",
    components: {CodeBlock},
    props: {
        hasSearchBox: Boolean,
        hasSearchButton: Boolean,
        isFullscreen: Boolean,
        searchBoxSelector: String,
        searchButtonSelector: String,
        searchTriggerSelector: String,
		source: String,
		searchBoxPlaceholder: {
			type: String,
			default: 'Search…'
		}
    },
    data(){
        return {
            sbC: 1,
            sbtnC:1,
            stC: 1
        };
    },
    methods: {
        isSimpleIdSelector(selector){
            const charBlackList = [" ", "[", "]", ".", ",", ":", ">"]
            selector = selector ?  selector.trim() : undefined;
            return selector && selector.trim().replace("#","").length > 0 && selector.trim().indexOf("#")===0 && charBlackList.reduce((acc, char)=>acc && selector.indexOf(char)===-1, true);
        },
        getSearchBoxId(){
            return this.searchBoxSelector && this.isSimpleIdSelector(this.searchBoxSelector) ? this.searchBoxSelector.substring(1).trim() : "searchBox";
        },
        getSearchButtonId(){
            return this.searchButtonSelector && this.isSimpleIdSelector(this.searchButtonSelector) ? this.searchButtonSelector.substring(1).trim() : "searchButton";
        },
        getSearchTriggerId(){
            return this.searchTriggerSelector && this.isSimpleIdSelector(this.searchTriggerSelector) ? this.searchTriggerSelector.substring(1).trim() : "ss360-trigger";
        }
    },
    computed: {
        searchBoxId(){
            this.sbC++;
            return this.getSearchBoxId();
        },
        searchButtonId(){
            this.sbtnC++;
            return this.getSearchButtonId();
        },
        searchTriggerId(){
            this.stC++;
            return this.getSearchTriggerId();
        }

    }
}
</script>

<style lang="css">
#installation-faqs .span {
	display: block;
	margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// src/components/InstallationFAQ.vue